'use client';

import React from 'react';
import { LeaderboardPage } from 'components/performance-lab/leaderboard/LeaderboardPage';
import type { LeaderboardPageData } from 'components/performance-lab/leaderboard/types';
import { useGlobalUI } from 'contexts/GlobalUIContext';
import { geistMono, inter, jetbrainsMono } from 'utils/fonts';

type PerformanceLabLeaderboardRouteProps = {
  leaderboardData: LeaderboardPageData;
};

const PerformanceLabLeaderboardRoute = ({
  leaderboardData,
}: PerformanceLabLeaderboardRouteProps) => {
  useGlobalUI({ headerCollaspable: false });

  return (
    <>
      <div
        className={`${inter.variable} ${inter.className} ${jetbrainsMono.variable} ${geistMono.variable}`}
      >
        <LeaderboardPage data={leaderboardData} />
      </div>
    </>
  );
};

export default PerformanceLabLeaderboardRoute;
